/* eslint-disable prettier/prettier */
import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeData } from 'utils/makeData'
import acceptInviteIcon from 'assets/images/profilepage-invite-accept.svg'
import refuseInviteIcon from 'assets/images/playroompage-cross.svg'
import friendStatus from 'assets/images/invite-friend-status.svg'
import { Col, Container, Row } from 'react-bootstrap'
import { useQuery } from 'react-query'
import { getListInvitationQuery, useAcceptInviteFriend } from 'dataLayer/user'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'


function InvitationMobile({ title }) {
	const { t } = useTranslation()
	const { data, isLoading } = useQuery(getListInvitationQuery('', ''))
	const [loading, setLoading] = useState(false)
	const [listInvitation, setListInvitation] = useState([])
	// let listInvitation = (data && data.list_invitation) || []
	const _acceptFriendSucess = result => {
		setLoading(!loading)
	}
	useEffect(() => {
		if (data && data.list_invitation) {
			setListInvitation(data.list_invitation)
		} else {
			setListInvitation([])
		}
	}, [data])
	const { mutate } = useAcceptInviteFriend(_acceptFriendSucess)
	const handleAcceptFriend = dataSelect => {
		mutate({
			friend_id: dataSelect.friend_id,
			invitation_friend_id: dataSelect.id,
			is_accept: 1,
		})
		let newList = listInvitation.filter(it => it.id != dataSelect.id)
		setListInvitation(newList)
	}
	const handleRefuseFriend = dataSelect => {
		mutate({
			friend_id: dataSelect.friend_id,
			invitation_friend_id: dataSelect.id,
			is_accept: 0,
		})
		let newList = listInvitation.filter(it => it.id != dataSelect.id)
		setListInvitation(newList)
	}

	// const invitation = makeData('invitation', 17)
	const titleAmount = `${title}`
	//  ${invitation.length < 10
	// 	? `(0${invitation.length})`
	// 	: `(${invitation.length})`
	// 	}
	// 	`

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(titleAmount)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	return (
		<Container fluid className="profilepage-content mobile invitation mt-3">
			<Row
				className="profilepage-content__body invitation header mt-3 py-0 px-2 px-sm-3 "
				style={{ height: 40, width: '100%' }}
			>
				<Col xs={12} style={{ fontSize: 14 }}>
					{t('profile.invitation.name')}
				</Col>
				{/* <Col xs={6} className="ps-0" style={{ fontSize: 14 }}>
					{t('profile.invitation.gold')}
				</Col> */}
			</Row>
			<Row className="profilepage-content__body invitation body mobile mt-3 py-2 px-2 px-sm-3" style={{ width: "100%" }}>
				{listInvitation.length > 0 ? (
					listInvitation?.map(item => {
						return (
							<div key={item?.id} className="d-flex align-items-center py-2 px-0">
								<Col xs={10} className="friend-info">
									<div className="friend-info__ava me-2">
										<img src={item?.image} alt="Inviter's avatar" />
										{/* {item.status === 1 ? (
											<img src={friendStatus} alt="Friend's status" />
										) : null} */}
									</div>
									<p style={{ fontSize: 12 }}>{item?.full_name}</p>
								</Col>
								{/* <Col xs={4} className="inviter-bet">
								<p style={{ fontSize: 12 }}>
									{new Intl.NumberFormat('lo').format(item?.bet)}
								</p>
							</Col> */}
								<Col xs={2} className="inviter-interact">
									<img onClick={() => handleAcceptFriend(item)} src={acceptInviteIcon} alt="Accept invite" />
									<img onClick={() => handleRefuseFriend(item)} src={refuseInviteIcon} alt="Refuse invite" />
								</Col>
							</div>
						)
					})
				) : (
					<div className="container--img__no-data  mobile">
						<img
							className="img--no-data  mobile"
							src={noDataIcon}
							alt="No reward is found"
						/>
					</div>
				)
				}
			</Row>
		</Container>
	)
}

export default InvitationMobile
